/**
 * @generated SignedSource<<4d500113994814852423571d6528963a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RequestResetPasswordEmailInput = {
  email: string;
};
export type ForgotPassword_RequestResetPasswordEmail_Mutation$variables = {
  input: RequestResetPasswordEmailInput;
};
export type ForgotPassword_RequestResetPasswordEmail_Mutation$data = {
  readonly requestResetPasswordEmail: {
    readonly email: string;
  } | null;
};
export type ForgotPassword_RequestResetPasswordEmail_Mutation = {
  response: ForgotPassword_RequestResetPasswordEmail_Mutation$data;
  variables: ForgotPassword_RequestResetPasswordEmail_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RequestResetPasswordEmailPayload",
    "kind": "LinkedField",
    "name": "requestResetPasswordEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ForgotPassword_RequestResetPasswordEmail_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ForgotPassword_RequestResetPasswordEmail_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c582517c2cf2355388d9ead7eb332f9a",
    "id": null,
    "metadata": {},
    "name": "ForgotPassword_RequestResetPasswordEmail_Mutation",
    "operationKind": "mutation",
    "text": "mutation ForgotPassword_RequestResetPasswordEmail_Mutation(\n  $input: RequestResetPasswordEmailInput!\n) {\n  requestResetPasswordEmail(input: $input) {\n    email\n  }\n}\n"
  }
};
})();

(node as any).hash = "2ce4687f53ddb76d306a7134df636e28";

export default node;
